import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const insightsPortalCampaignInsightsAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.InsightsPortalCampaign],
    warehouseFeatureToggles: [FeatureToggle.InsightsCampaignInsights],
    notWarehouseFeatureToggles: [FeatureToggle.InsightsCampaignInsightsDisabledRetailers],
    notFeatureToggles: [FeatureToggle.InsightsCampaignInsightsDisabledRetailers],
  },
]
